/**
 * Repository - LocalStorageAccountRepository
 *
 * Implémentation du repository de comptes
 * Note: Ce repository n'est plus utilisé - les comptes sont récupérés via HttpAccountRepository
 */

import { IAccountRepository } from '../../application/ports/output/IAccountRepository';
import { Account } from '../../domain/entities/Account';
import { AccountNumber } from '../../domain/value-objects/AccountNumber';

export class LocalStorageAccountRepository implements IAccountRepository {
  constructor() {
    // Ce repository est obsolète et ne devrait plus être utilisé
  }

  /**
   * Récupère un compte par son numéro
   */
  async findByNumber(_accountNumber: AccountNumber): Promise<Account | null> {
    throw new Error('LocalStorageAccountRepository is deprecated. Use HttpAccountRepository instead.');
  }

  /**
   * Récupère un compte par son numéro (avec string)
   */
  async findByNumberString(_accountNumber: string): Promise<Account | null> {
    throw new Error('LocalStorageAccountRepository is deprecated. Use HttpAccountRepository instead.');
  }

  /**
   * Récupère tous les comptes d'un client
   */
  async findByClientId(_clientId: string): Promise<Account[]> {
    throw new Error('LocalStorageAccountRepository is deprecated. Use HttpAccountRepository instead.');
  }

  /**
   * Récupère tous les comptes
   */
  async findAll(): Promise<Account[]> {
    throw new Error('LocalStorageAccountRepository is deprecated. Use HttpAccountRepository instead.');
  }

  /**
   * Vérifie si un compte existe
   */
  async exists(_accountNumber: AccountNumber): Promise<boolean> {
    throw new Error('LocalStorageAccountRepository is deprecated. Use HttpAccountRepository instead.');
  }
}
